import {NgModule} from "@angular/core";
import {CriiptoAutentiseringPopupKomponentAvhengigheter} from "./komponenter/criipto-autentisering-popup/criipto-autentisering-popup";

@NgModule({
    providers: [
        CriiptoAutentiseringPopupKomponentAvhengigheter
    ]
})
export class AutentiseringModul {

}
